import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Lock, AlertCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Skip login if already authenticated
  useEffect(() => {
    const token = localStorage.getItem("mf_admin_token");
    if (token) {
      axios
        .get(`${API}/admin/me`, { headers: { Authorization: `Bearer ${token}` } })
        .then(() => navigate("/admin"))
        .catch(() => localStorage.removeItem("mf_admin_token"));
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/admin/login`, { email, password });
      localStorage.setItem("mf_admin_token", data.token);
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Login fejlede");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background py-16 px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 border border-border/40">
        <div className="text-center mb-8">
          <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
            <Lock className="h-6 w-6 text-primary" />
          </div>
          <h1 className="font-heading text-2xl md:text-3xl font-bold text-primary">
            Admin login
          </h1>
          <p className="text-sm text-muted-foreground mt-2">
            Adgang for ejer
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4" data-testid="admin-login-form">
          <div>
            <label className="text-sm font-medium text-primary mb-1 block">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="hej@minfesttale.dk"
              autoComplete="username"
              className="w-full px-4 py-3 rounded-lg border border-border bg-muted/30 text-primary focus:outline-none focus:ring-2 focus:ring-secondary"
              data-testid="admin-email-input"
            />
          </div>
          <div>
            <label className="text-sm font-medium text-primary mb-1 block">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              className="w-full px-4 py-3 rounded-lg border border-border bg-muted/30 text-primary focus:outline-none focus:ring-2 focus:ring-secondary"
              data-testid="admin-password-input"
            />
          </div>

          {error && (
            <div className="flex items-start gap-2 text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg p-3" data-testid="admin-error">
              <AlertCircle className="h-4 w-4 flex-shrink-0 mt-0.5" />
              <span>{error}</span>
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-primary hover:bg-primary/90 text-primary-foreground font-medium py-3 rounded-lg transition-colors disabled:opacity-50"
            data-testid="admin-login-submit"
          >
            {loading ? "Logger ind..." : "Log ind"}
          </button>
        </form>
      </div>
    </div>
  );
}
